import { isEmpty, map, filter, includes } from "lodash";
import app from '../angular_app.es6';

app.directive('stdWordclouds', [ '$rootScope', '$timeout', '$http', 'OrientationService', ($rootScope, $timeout, $http, OrientationService) => {
  return {
    restrict: 'E',
    scope: {
      thoughtBubbleCard: "=?",
      customThoughtBubbleTitle: '@',
      thoughtBubbleAnswerHelp: '@',
      noConceptFocus: "=?",
      conceptId: "=",
      filter: "=",
      selectedTool: "=",
      customTitle: '@',
      hideExport: '@',
      pinCount: '@',
      answerHelp: '@',
      answerHelpFor: '@',
      pinTitle: '@',
      unpinTitle: '@',
      isAdmin: '='
    },
    template: require('./std_wordclouds_template.html'),

    link: ($scope, $element) => {
      if (!$scope.pinCount) {$scope.pinCount = 3;}

      $scope.helpText = (index) => {
        if (!$scope.answerHelpFor) {return $scope.answerHelp;}
        const split = map($scope.answerHelpFor.split(','), (el) => parseInt(el, 10));
        return includes(split, index) ? $scope.answerHelp : '';
      };

      $scope.data = {};
      $scope.config = {
        filterOptions: []
      };

      $scope.state = { filter: $scope.filter, selectedOrientation: OrientationService.define() };

      $scope.$on('needSentimentsUpdate', () => {
        $scope.getData();
      });

      $scope.getData = (updateFilters) => {
        if ($scope.loading) {return;}

        $scope.loading = true;
        $rootScope.$broadcast('startedGettingData');

        const getParams = map($scope.state.filter || [], (filter) => { return `filter[]=${filter}`; }).join('&'),
          url = `/dashboard/api/open_ends/concepts/${$scope.conceptId}`;

        if (!$scope.noConceptFocus) {
          $http.get(`${url}?${getParams}`).then(
            (response) => {
              $scope.loading = false;
              $rootScope.$broadcast('stoppedGettingData');
              $scope.data = response.data;
              $scope.data.selected = filter($scope.data.selected, (el) => {
                return $scope.selectedTool.markup_ids.findIndex(el.metric.id) != -1;
              });
              if (updateFilters) {$scope.config.filterOptions = $scope.data.filter_options;}
            },
            (error) => {
            }
          );
        } else {
          $scope.loading = false;
          $rootScope.$broadcast('stoppedGettingData');
        }
      };

      $scope.$watch(() => { return `${$scope.filter}${$scope.conceptId}`;}, (newValue, oldValue) => {
        if (!$scope.loading) {
          $scope.state.filter = $scope.filter;
          $scope.getData();
        }
      });

      $scope.customOrientations = () => { return OrientationService.customList; };
      OrientationService.run();
      $scope.$on('orientationChange', (event, orientation) => { $scope.state.selectedOrientation = orientation; });

      $scope.fontFamily = 'Arial,Helvetica Neue,Helvetica,sans-serif';

      if (isEmpty($scope.data)) {$scope.getData(true);}
    }
  };
} ]);


